export const FETCHING = 'FETCHING';
export const FAILED = 'FAILED';
export const RECEIVED_VERIFY_RESULT = 'RECEIVED_VERIFY_RESULT';
export const EMAIL_CHANGED = 'EMAIL_CHANGED';
export const RESET = 'RESET';
export const EMAIL_OVERRIDE = 'EMAIL_OVERRIDE';
export const CHECK_EMAIL_INPUT_STATE = 'CHECK_EMAIL_INPUT_STATE';
